module.exports = __webpack_public_path__ + "media/images/bottom_layer_popup-93175bdd5370426f5a9d712096f64aba.png";